import  gql  from 'graphql-tag'

export const financialAssessments = gql`query FinancialAssessments($status: String, $analyst: ID, $office: ID,  $createdAt_Gt: DateTime, $createdAt_Lt: DateTime, $debtor_Person_IdentificationNumber: String, $maxAssessments: Boolean) {
    financialAssessments(status: $status, analyst: $analyst, office: $office, createdAt_Gt: $createdAt_Gt, createdAt_Lt: $createdAt_Lt, debtor_Person_IdentificationNumber: $debtor_Person_IdentificationNumber, maxAssessments: $maxAssessments) {
      edges{
        node{
          fm102{
              id
          }
          id
          financialAssessmentId
          jsonObject
          status
          createdAt
          debtor{
            fm100{
                id
            }
            id
            creditstudySet{
              edges{
                node{
                  id
                  productType{
                    id
                  }
                }
              }
            }
            person{
              id
              fullName
              identificationNumber
            }
            spouse{
                person{
                    id
                }
                creditstudy{
                    id
                }
            }
          }
          codebtorSet{
            edges{
              node{
                id
                fm100{
                    id
                }
                creditstudySet{
                  edges{
                    node{
                      id
                      productType{
                        id
                      }
                    }
                  }
                }
                person{
                  id
                  fullName
                  identificationNumber
                }
              }
            }
          }
        }
      }
    }
  }`;
